<template>
  <div class="backdrop">
    <div class="land">
      <div class="Ierror">
        <span class="cha">×</span>
        <h1 class="LHeader">欢迎登录以诺</h1>
        <p class="LWen">如果您第一次登录，我们将为您创建以诺账户</p>
      </div>
      <input type="text" class="numbert" placeholder="手机号" maxlength="11" />
      <p class="Fnumber">请输入正确的11位手机号!</p>
      <div class="tuCode">
        <input
          type="text"
          class="chart"
          placeholder="请输入图形验证码"
          maxlength="6"
        />
        <span class="chartCode"><img :src="imgData" /></span>
      </div>
      <div class="duanCode">
        <input
          type="text"
          class="code"
          placeholder="短信验证码"
          maxlength="6"
        />
        <button class="codeBtn" :disabled="btn">获取验证码</button>
        <!--<p class="down">{{time}}秒后重发</p>-->
        <p class="prompt">验证码错误请重新输入</p>
      </div>
      <div class="logn">登录</div>
      <div class="policyBox">
        <input
          type="checkbox"
          v-model="agreedToPolicy"
          class="agreedToPolicy"
          id="agreeToPolicy"
        />
        同意<a
          target="_blank"
          href="https://nbp-activity-bucket.noahgroup.com/fed/20260403/%E4%BB%A5%E8%AF%BA%E6%95%99%E8%82%B2%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96v202501.pdf"
          >《以诺教育隐私政策》</a
        >
      </div>
      <!--<div class="weixin">
 				<img src="../../assets/weixin.png" class="weiTu"/>
 				<p>微信登陆</p>
 			</div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: "land",
  data() {
    return {
      agreedToPolicy: false,
      time: 60,
      btn: true,
      imgData: "",
    };
  },
  methods: {},
  mounted() {
    var that = this;
    /*------------------------------失去焦点----------------------------*/
    $(".numbert").bind("input propertychange", function () {
      var re = /^[1][3,4,5,7,8][0-9]{9}$/;
      var sr = $(".numbert").val();
      if (sr.length == 11) {
        if (re.test(sr)) {
          $(".codeBtn").css({ background: "#01b784", color: "#fff" });
          that.btn = false;
          $(".Fnumber").css({ display: "none" });
          /*------------------------------获取短信验证码----------------------------*/
          $(".codeBtn").click(function () {
            that.btn = true;
            var icode = $(".chart").val();
            that
              .$ajax({
                method: "post",
                url: "/api/auth/sendPhoneCode",
                params: { phone: sr, need_img_code: 1, img_code: icode },
              })
              .then(function (data) {
                var erro = data.data;
                if (erro.error) {
                  if (erro.error.code == 16006) {
                    $(".tuCode").css({ display: "block" });
                    //							$(".Ierror").css({"display":"none"})
                    clearInterval(timer);
                    $(".codeBtn").html("重发验证码");
                    $(".codeBtn").css({ background: "#01b784", color: "#fff" });
                    that.btn = false;
                  }
                  if (erro.error.code == 16001) {
                    clearInterval(timer);
                    $(".codeBtn").html("重发验证码");
                    $(".codeBtn").css({ background: "#01b784", color: "#fff" });
                    that.btn = false;
                    that
                      .$ajax({
                        method: "post",
                        url: "/api/auth/captchaGet",
                        params: { phone: sr },
                      })
                      .then(function (data) {
                        that.imgData = data.data.result.imgData;
                      })
                      .catch(function (err) {
                        console.log(err);
                      });
                  }
                  $(".prompt")
                    .css({ display: "block" })
                    .html(erro.error.message);
                } else {
                  $(".prompt").css({ display: "none" });
                }
              })
              .catch(function (err) {
                console.log(err);
              });

            $(".codeBtn").css({ background: "#e6e6e6", color: "#000" });
            $(".Fnumbert").css({ display: "none" });
            /*----------------------------倒计时-------------------------------*/
            var timer = setInterval(function () {
              --that.time;
              $(".codeBtn").html("重发" + that.time + "s");
              if (that.time == 0) {
                clearInterval(timer);
                that.time = 60;
                $(".codeBtn").html("重发验证码");
                $(".codeBtn").css({ background: "#01b784", color: "#fff" });
                that.btn = false;
              } else {
                that.btn = true;
              }
            }, 1000);
          });
          /*----------------------------验证码-------------------------------*/
          that
            .$ajax({
              method: "post",
              url: "/api/auth/captchaGet",
              params: { phone: sr },
            })
            .then(function (data) {
              that.imgData = data.data.result.imgData;
            })
            .catch(function (err) {
              console.log(err);
            });
          /*--------------------------------------------------------------*/
        } else {
          $(".Fnumber").css({ display: "block" });
        }
      } else {
        $(".codeBtn").css({ background: "#e6e6e6", color: "#000" });
        that.btn = true;
      }
    });

    /*----------------------------获取焦点-------------------------------*/
    $(".numbert").focus(function () {
      $(".Fnumber").css({ display: "none" });
    });
    $(".chart").blur(function () {
      $(".prompt").css({ display: "none" });
    });
    $(".code").blur(function () {
      $(".prompt").css({ display: "none" });
    });
    /*---------------------------登陆-----------------------------------*/
    $(".logn").click(function () {
      if (!$("#agreeToPolicy").is(":checked")) {
        alert("请先同意并勾选协议");
        return;
      }
      var pcode = $(".code").val();
      var ph = $(".numbert").val();
      var icode = $(".chart").val();
      that
        .$ajax({
          method: "post",
          url: "/api/auth/pcLogin",
          params: { phone: ph, phone_code: pcode, img_code: icode },
        })
        .then(function (data) {
          if (data.data.error) {
            $(".prompt")
              .css({ display: "block" })
              .html(data.data.error.message);
            /*---------------------------验证码刷新-----------------------------------*/
            if (data.data.error.code == 16010) {
              $(".chartCode").click(function () {
                var ph = $(".numbert").val();
                that
                  .$ajax({
                    method: "post",
                    url: "/api/auth/captchaGet",
                    params: { phone: ph },
                  })
                  .then(function (data) {
                    that.imgData = data.data.result.imgData;
                  })
                  .catch(function (err) {
                    console.log(err);
                  });
              });
            }
          } else if (data.data.result.status == 1) {
            localStorage.setItem("token", data.data.result.token);
            $(".backdrop").css({ display: "none" });
            history.go(0);
          } else {
            $(".prompt").css({ display: "none" });
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    });
    /*---------------------------验证码刷新-----------------------------------*/
    $(".chartCode").click(function () {
      var ph = $(".numbert").val();
      that
        .$ajax({
          method: "post",
          url: "/api/auth/captchaGet",
          params: { phone: ph },
        })
        .then(function (data) {
          that.imgData = data.data.result.imgData;
        })
        .catch(function (err) {
          console.log(err);
        });
    });
    /*---------------------------点击关闭-----------------------------------*/
    $(".cha").click(function () {
      $(".backdrop").css({ display: "none" });
    });
  },
};
</script>

<style scoped="scoped">
.policyBox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
.agreedToPolicy {
  margin-right: 5px;
}
.backdrop {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  left: 0;
  top: 0;
  display: none;
  z-index: 999;
}
.cha {
  position: absolute;
  right: 0;
  top: 0;
  width: 36px;
  line-height: 36px;
  font-size: 36px;
  text-align: center;
  color: #a3a3a2;
}
.cha:hover {
  color: #01b784;
  background: #e6e6e6;
}
.land {
  width: 340px;
  height: 380px;
  background: #fff;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -170px;
  margin-top: -190px;
  z-index: 5;
}
.LHeader {
  font-size: 20px;
  text-align: center;
  margin-top: 30px;
  font-weight: 400;
}
.LWen {
  text-align: center;
  margin-top: 12px;
  font-size: 12px;
}
.numbert {
  width: 260px;
  height: 40px;
  margin: 20px 0 0 40px;
  border: 1px solid #e6e6e6;
  text-indent: 20px;
  font-size: 13px;
  vertical-align: middle;
}
.Fnumber {
  position: relative;
  top: 5px;
  left: 40px;
  font-size: 12px;
  display: none;
}
.code {
  width: 156px;
  height: 40px;
  margin: 30px 0 0 40px;
  border: 1px solid #e6e6e6;
  text-indent: 20px;
  float: left;
}
.codeBtn {
  width: 104px;
  height: 40px;
  border: 0;
  float: left;
  margin-top: 30px;
  background: #e6e6e6;
  color: #000;
  outline: none;
}
.logn {
  width: 260px;
  line-height: 40px;
  border: 0;
  margin: 70px 0 0 40px;
  background: #01b784;
  color: #fff;
  text-align: center;
}
/*.down{font-size: 12px;position:absolute;right:60px;top:70px;display:none;}*/
.chart {
  width: 138px;
  height: 40px;
  border: 1px solid #e6e6e6;
  margin: 0 0 0 40px;
  text-indent: 20px;
  float: left;
}
.chartCode {
  width: 100px;
  height: 40px;
  background: red;
  display: block;
  float: left;
  margin: 0 0 0 22px;
}
.chartCode img {
  width: 100px;
  height: 40px;
}
.tuCode {
  display: none;
  height: 40px;
  margin-top: 10px;
}
.duanCode {
  position: relative;
  height: 30px;
}
.In {
  position: relative;
}
.prompt {
  position: absolute;
  top: 74px;
  left: 40px;
  display: none;
  color: #ff2323;
}
/*.weixin{width:100%;text-align: center;position: absolute;bottom:16px;}
      .weiTu{margin-left:44%;margin-bottom: 5px;}*/
</style>



// WEBPACK FOOTER //
// land.vue?4a0514df